import React from "react";
import { ls } from "../../locale"


export default function SeatBenefit() {

  const benefit = ls.t('SeatPage.Benefit')

  return (
    <div className="tw-p-2 tw-mb-4">
      {Array.isArray(benefit) && benefit.map(b => <Item key={b.Title} icon={b.Icon} title={b.Title} description={b.Desc} />) }
    </div>
  )
}

function Item({ icon, title, description }: { icon: React.ReactNode, title: string, description: string }) {
  return (
    <div className="tw-p-2">
      <div className="tw-flex tw-flex-row">
        <div className="tw-flex tw-justify-center tw-items-center tw-px-2">
          <i className={`picon picon-${icon}`} />
        </div>
        <div>
          <div className="sa-text-green tw-text-sm">{title}</div>
          <div>{description}</div>
        </div>
      </div>
    </div>
  )
}